// pricing-popup.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PricingPopupComponent } from './pricing-popup.component';
import { SigninWithOtpModule } from '../../../auth/_components/signin-with-otp/signin-with-otp.module';
import { ThankYouPageModule } from "./../../_components/thankyou-modal/thankyou-modal.module";
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@NgModule({
  declarations: [PricingPopupComponent],
  imports: [CommonModule,
    SigninWithOtpModule,
    ThankYouPageModule  
  ],
  exports: [PricingPopupComponent] ,
  schemas: [CUSTOM_ELEMENTS_SCHEMA] 
})
export class PricingPopupModule {}
